// Save a blob response (axios `responseType: 'blob'`) to the user's machine.
// Authenticated downloads can't be plain links — the API wants a Bearer header —
// so the bytes are fetched through axios and handed to a temporary <a download>.
export const downloadBlob = (data, filename) => {
  const url = window.URL.createObjectURL(data instanceof Blob ? data : new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
